type Options = {
  id: string;
  scrollWhenFocus?: boolean;
};
export function focusTargetById({ id, scrollWhenFocus = false }: Options) {
  const target = document.getElementById(id);
  if (target) {
    target.focus({ preventScroll: !scrollWhenFocus });
  }
}
